import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'
import AddButton from 'components/AddButton'
import TermList from './TermList'
import { objectTerms } from 'selectors/lease'

let select = dirtyRead(
	(state, props) => ({
		lease: doc(state, props.objectID)
	  , lastTerm: objectTerms(state, props)[objectTerms(state, props).length-1]
	})
)

export class Terms extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="lease/terms"
				title="Terms"
				rightButton={<AddButton object={{
						type:"lease"
					  , parentID: props.objectID
					  , date: Moment(new Date()).format('YYYY-MM-DD')
					  , dateFrom: props.lastTerm && props.lastTerm.dateTill && Moment(props.lastTerm.dateTill).add("1", "day").format("YYYY-MM-DD")
					  , dateTill: props.lastTerm && props.lastTerm.dateTill && Moment(props.lastTerm.dateTill).add("1", "year").format("YYYY-MM-DD")
					  , rent: props.lastTerm && props.lastTerm.rent
					  , notificationPeriod: props.lastTerm && props.lastTerm.notificationPeriod
					  , lateFee: props.lastTerm && props.lastTerm.lateFee
					  , securityDeposit: props.lastTerm && props.lastTerm.securityDeposit
					  , petDeposit: props.lastTerm && props.lastTerm.petDeposit
					}}
				/>}
			>
				<TermList objectID={props.objectID} />
            </Section>
		)
	}
}

export default connect(select, dataActions)(Terms)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/Terms.js